import r, { useMemo as U, useEffect as V } from "react";
import C from "./index136.mjs";
import { RoomTile as Y } from "./index137.mjs";
import { Header as w } from "./index89.mjs";
import { useAtomValue as u, useSetAtom as R } from "jotai";
import { giftCardCurrencyAtom as q, cartItemsAtom as j } from "./index34.mjs";
import { getConfigPropertyAtomCreator as J, ConfigProperty as Q, ViewLayout as X } from "./index13.mjs";
import { setCurrentStepAtom as Z } from "./index25.mjs";
import { bannerAtom as $, setBannerAtom as ee, isDatePickerPageAtom as te } from "./index58.mjs";
import { isEditSearchAtom as re } from "./index26.mjs";
import { selectedRateAtom as oe } from "./index60.mjs";
import { setSelectedRateIdAtom as se } from "./index61.mjs";
import { selectedRoomAtom as ne } from "./index63.mjs";
import { selectedGiftCardAtom as ie, setSelectedGiftCardAtom as ae } from "./index64.mjs";
import { useCartManager as le } from "./index138.mjs";
import { useTracking as me } from "./index88.mjs";
import { useHotelConfig as ce } from "./index93.mjs";
import { useResults as pe } from "./index139.mjs";
import "@amenitiz/design-system";
import { RoomPage as _e } from "./index140.mjs";
import { GiftCardPage as de } from "./index141.mjs";
import { TermsAndConditions as ue } from "./index108.mjs";
import { ROOM_SELECTION_HASH as fe } from "./index87.mjs";
import { Banner as ge } from "./index142.mjs";
import F from "classnames";
import { track as T } from "./index9.mjs";
import { TRACK_EVENT_TYPE as N, TRACK_EVENT as A } from "./index10.mjs";
import { getSubscriptionPlanRoot as d } from "./index14.mjs";
import { NoResults as ye } from "./index143.mjs";
const Ee = (t, n, o, i, l, m, f, g, c, p) => {
  const I = n === "0" ? A.REMOVE_FROM_CART : A.ADD_TO_CART;
  T(I, I, {
    hotel_id: m,
    property_type: f,
    property_size: g,
    subscription_plan: d(c),
    multi_room: p,
    ecommerce: {
      currency: o,
      value: parseFloat(t.total_price) * parseInt(n),
      items: [
        {
          item_id: i.id.toString(),
          item_name: t.name,
          item_type: i.room_type,
          is_cottage: i.room_type === "cottage",
          price: parseFloat(t.total_price),
          currency: o,
          quantity: parseInt(n),
          promo_code_added: l
        }
      ]
    }
  });
}, he = ({
  rooms: t,
  currency: n,
  searchInputs: o,
  isExpanded: i,
  onClose: l,
  onEditDates: m,
  applyCityTaxRule: f,
  cityTaxIncludedAllRooms: g
}) => {
  const c = u(ne), p = u(oe), { addOrRemoveFromCart: I } = le(), { show: x, message: k } = u($), M = R(ee), L = u(te), {
    hotelId: y,
    hotelName: B,
    propertySize: E,
    propertyType: h,
    subscriptionPlan: a,
    googleHotelLink: b
  } = ce(), z = R(se), D = R(re), H = u(j), P = u(
    U(() => J(Q.VIEW_LAYOUT), [])
  ) === X.FULL_SCREEN;
  V(() => {
    let e = "";
    L ? e = "date_picker_page" : e = "direct", T(A.VIEW, N.VIEW_AVAILABLE_ROOMS, {
      total_results_shown: t.length,
      source: e,
      experiment_upgraded_room_selection: "A",
      hotel_id: y,
      property_type: h,
      property_size: E,
      subscription_plan: d(a)
    });
  }, [
    t,
    L,
    y,
    h,
    E,
    a
  ]), V(() => {
    x && T(A.VIEW, N.BLOCKED_ROOMS_BANNER_SHOWN, {
      hotel_id: y,
      property_type: h,
      property_size: E,
      subscription_plan: d(a),
      issue_type: [k]
    });
  }, [
    x,
    k,
    y,
    h,
    E,
    a
  ]);
  const v = () => {
    T(A.CLICK, N.SEARCH_TOP_BAR_CLICKED, {
      hotel_id: y,
      property_type: h,
      property_size: E,
      subscription_plan: d(a)
    }), D(!0), z(0), m();
  }, G = (e, _, s, S, O) => {
    const W = {
      roomId: s.id,
      motherId: s.mother_id,
      merchantId: s.merchant_id,
      roomName: s.name,
      maxOccupancy: s.max_occupancy,
      cityTaxIncluded: s.city_tax_included,
      maxAdults: s.max_adults,
      maxChildren: s.max_children
    }, K = {
      pricingTypeId: S || _.id,
      pricingTypeName: _.name,
      promoCodeAdded: O || !1,
      totalPrice: _.total_price,
      insuranceEligible: _.sales_term.insurance_eligible,
      ...S && { promotionId: _.id }
    };
    I(parseInt(e), W, K), Ee(
      _,
      e,
      n,
      s,
      !1,
      y,
      h,
      E,
      a,
      parseInt(e) > 1 || H.length > 0
    );
  };
  return p ? /* @__PURE__ */ r.createElement(ue, { salesTerms: p.sales_term }) : c ? /* @__PURE__ */ r.createElement(_e, { ...c, searchInputs: o }) : /* @__PURE__ */ r.createElement(
    "div",
    {
      "data-testid": "results",
      className: F(C.results_container, {
        [C.results_container_no_rooms]: !t.length,
        [C.results_container_fullscreen]: P
      })
    },
    P ? /* @__PURE__ */ r.createElement(
      w,
      {
        subTitle: b === "true" && d(a) !== "sales_pro" ? I18n.t("booking_engine.results.welcome_message") : void 0,
        title: b === "true" && d(a) !== "sales_pro" ? B : I18n.t("booking_engine.results.title"),
        searchInputs: o,
        onClose: l,
        onBack: v,
        isFullScreenLayout: !0,
        roomsCount: t.length
      }
    ) : /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(
      w,
      {
        subTitle: b === "true" && d(a) !== "sales_pro" ? I18n.t("booking_engine.results.welcome_message") : void 0,
        title: b === "true" && d(a) !== "sales_pro" ? B : I18n.t("booking_engine.results.title"),
        searchInputs: o,
        onClose: l,
        onBack: v
      }
    ), /* @__PURE__ */ r.createElement(
      "div",
      {
        className: C["rooms-available"],
        "data-testid": "rooms-available"
      },
      I18n.t("booking_engine.results.rooms_available", {
        count: t.length.toString()
      })
    )),
    t.length ? t.map((e) => /* @__PURE__ */ r.createElement(
      Y,
      {
        key: e.id,
        id: e.id,
        images: e.photo_thumbs,
        name: e.name,
        size: e.size,
        beds: e.beds,
        motherId: e.mother_id,
        merchantId: e.merchant_id,
        maxOccupancy: e.max_occupancy,
        maxChildren: e.max_children,
        maxAdults: e.max_adults,
        description: e.description,
        rates: e.rate_plans,
        roomType: e.room_type,
        motherName: e.mother_name,
        cityTaxIncluded: f ? g : e.city_tax_included,
        currency: n,
        noOfRooms: e.number_of_rooms,
        isExpanded: i,
        onRateSelect: (_, s, S, O) => G(
          _,
          s,
          e,
          S,
          O
        ),
        onClose: l
      }
    )) : /* @__PURE__ */ r.createElement(ye, null),
    x ? /* @__PURE__ */ r.createElement(
      ge,
      {
        title: k || "",
        classes: F(C.rates_banner, {
          [C.rates_banner_expanded]: i
        }),
        onClose: () => {
          M({
            show: !1,
            message: null
          });
        }
      }
    ) : null
  );
}, Ce = ({
  isExpanded: t,
  setIsExpanded: n,
  onClose: o,
  onEditDates: i,
  roomId: l
}) => {
  me(fe);
  const {
    rooms: m,
    currency: f,
    applyCityTaxRule: g,
    searchInputs: c,
    cityTaxIncludedAllRooms: p
  } = pe(l);
  return m ? /* @__PURE__ */ r.createElement(
    he,
    {
      rooms: m,
      currency: f,
      searchInputs: c,
      isExpanded: t,
      setIsExpanded: n,
      onClose: o,
      onEditDates: i,
      applyCityTaxRule: g,
      cityTaxIncludedAllRooms: p
    }
  ) : null;
}, Xe = ({
  isExpanded: t,
  setIsExpanded: n,
  onClose: o,
  onEditDates: i,
  roomId: l
}) => {
  const m = u(ie), f = u(q), g = R(ae), c = R(Z);
  if (m) {
    const p = () => {
      g(null), c(0);
    };
    return /* @__PURE__ */ r.createElement(
      de,
      {
        ...m,
        currency: f,
        onBack: p,
        onClose: o
      }
    );
  }
  return /* @__PURE__ */ r.createElement(
    Ce,
    {
      isExpanded: t,
      setIsExpanded: n,
      onClose: o,
      onEditDates: i,
      roomId: l
    }
  );
};
export {
  Xe as ItemSelection
};
